var scroll = function(vm,load,pageSize,typeNumber,ListIndex){
    if(typeof ListIndex === "undefined") ListIndex=0
    console.log(ListIndex)
    return new Scroll.prototype.init(vm,load,pageSize,typeNumber,ListIndex)
}

function Scroll(){}

Scroll.prototype = {
    constructor: Scroll,
    init:function(vm,load,pageSize,typeNumber,ListIndex){
        this._vm = vm
        this._trigger = vm.$el
        this._typeNumber = typeNumber || 1
        this._load = load
        this._pageParam = {}
        this._loadState = {}

        //初始化当前数据类型
        // this._typeIndex = 0
        this._typeIndex = ListIndex

        //初始化加载状态
        this.initLoadState()
        //初始化分页参数
        this.initPageParam(pageSize)
        //初始化加载事件
        this._loadHandler = this.handlerFactory()
        //给实例添加参数
        vm.loadState = this._loadState
        vm.pageParam = this._pageParam
        //读取一页
        this.loadOnePage()
    }
}

Scroll.prototype.init.prototype = Scroll.prototype

//初始化当前数据
Scroll.prototype.initLoadState = function(){
    if(this._typeNumber == 1){
        this._loadState.stop = false
        this._loadState.loading = false
        this._loadState.loaded = false
    }
    else{
        this._loadState = []
        for(var i =0;i<this._typeNumber;i++){
           this._loadState.push({
                'stop':false,
                'loading':false,
                'loaded':false
            })
        }
    }
}

//初始化分页参数
Scroll.prototype.initPageParam = function(pageSize){
    if(this._typeNumber == 1){
        this._pageParam.size = pageSize
        this._pageParam.index = 1
    }
    else{
        this._pageParam = []
        for(var i =0;i<this._typeNumber;i++){
            this._pageParam.push({
                'size': pageSize,
                'index': 1
            })
        }
    }
}

//滚动监听事件
Scroll.prototype.handler = function(){
    //如果已经停止加载，返回
    if(this._loadState.stop || (this._loadState.__proto__.constructor == Array && this._loadState[this._typeIndex].stop)){
        this.removeHandler()
        return
    }
    // console.log('未停止加载')
    //滚动条移动距离+视窗+提前量 > 文档高度
    if (window.scrollY + window.innerHeight ==  this._trigger.clientHeight) {
        // console.log('未停止加载')
        if(this._loadState.loading || (this._loadState.__proto__.constructor == Array && this._loadState[this._typeIndex].loading)){
            //如果正在加载中，返回
            return
        }
        else{
            this.loadOnePage()
        }
    }
}

//监听工厂
Scroll.prototype.handlerFactory = function(){
    var that = this
    //返回一个无参函数
    return function(){
        that.handler(that._load)
    }
}

//添加监听
Scroll.prototype.addHandler = function(){
    window.addEventListener('scroll',this._loadHandler)
}

//移除监听
Scroll.prototype.removeHandler = function(){
    window.removeEventListener('scroll', this._loadHandler)
}

//读取一页
Scroll.prototype.loadOnePage = function(){
    this.setLoadState(true,false)
    var promise = this._load()
    var that = this
    //接口调用成功
    promise.then(function(dataLen){
        let pageParam = that._pageParam[that._typeIndex] || that._pageParam
        //这里回调返回数据集长度
        if(dataLen == null){
            //接口调用返回false
            that.setLoadState(false,true)
        }
        else if(dataLen < pageParam.size){
            //返回的数据不足一页
            that.setLoadState(false,true)
            that.addPage()
        }
        else{
            that._loadState.loading = false
            that.setLoadState(false,false)
            that.addPage()
        }
    }).catch(function(){

    })
}

//设置加载状态
Scroll.prototype.setLoadState = function(loading,stop){
    if(this._typeNumber == 1){
        this._loadState.stop = stop
        this._loadState.loading = loading
        this._loadState.loaded = true
        this._vm.loadState = this._loadState
    }
    else{
        this._loadState[this._typeIndex] = {
            'stop':stop,
            'loading':loading,
            'loaded':true
        }
        this._vm.loadState.splice(this._typeIndex, 1, this._loadState[this._typeIndex])
    }
}

//增加一页
Scroll.prototype.addPage = function(){
    let pageParam = this._pageParam[this._typeIndex] || this._pageParam
    var pageIndex =  Number(pageParam.index) + 1
    if(this._typeNumber == 1){
        this._pageParam.index = pageIndex
    }
    else{
        this._pageParam[this._typeIndex].index = pageIndex
    }
}

//刷新当前页
Scroll.prototype.refresh= function(){
    if(this._typeNumber == 1){
        this._pageParam.index = 1
        this._loadState.stop = false
        this._loadState.loading = false
        this._loadState.loaded = true
    }
    else{
        this._pageParam[this._typeIndex].index = 1
        this._loadState[this._typeIndex] = {
            'stop':false,
            'loading':false,
            'loaded':false
        }
    }
    this.addHandler()
    this.loadOnePage()
}

//刷新全部页(多于1页可用)
Scroll.prototype.refreshAll= function(){
    for(var i = 0;i < this._typeNumber;i++){
        this._pageParam[i].index = 1
        this._loadState[i] = {
            'stop':false,
            'loading':false,
            'loaded':false
        }
    }
    this.addHandler()
    this.loadOnePage()
}

Scroll.prototype.changeType = function(index){
    this._typeIndex = index
    if(!this._loadState[this._typeIndex].loaded){
        this.refresh()
    }
}

Scroll.prototype.OnlychangeType = function(index){
    this._typeIndex = index
    if(!this._loadState[this._typeIndex].loaded){

        if(this._typeNumber == 1){
            this._pageParam.index = 1
            this._loadState.stop = false
            this._loadState.loading = false
            this._loadState.loaded = true
        }
        else{
            this._pageParam[this._typeIndex].index = 1
            this._loadState[this._typeIndex] = {
                'stop':false,
                'loading':false,
                'loaded':true
            }
        }
        this.addHandler()

    }
}




export default{
    Create:scroll
}


// WEBPACK FOOTER //
// ./src/utils/loading.js